import script from "./pickStore.vue?vue&type=script&setup=true&lang=js"
export * from "./pickStore.vue?vue&type=script&setup=true&lang=js"

import "./pickStore.vue?vue&type=style&index=0&id=0dd8429e&lang=css"

const __exports__ = script;

export default __exports__